const enGB = {
    messages: {
        datatable: {
            matchMode: {
                startsWith: 'Starts with',
                contains: 'Contains',
                notContains: 'Does not contain',
                endsWith: 'Ends with',
                equals: 'Equals',
                notEquals: 'Not equals',
                in: 'In',
                lessThan: 'Less than',
                lessThanOrEqual: 'Less than or equal',
                greaterThan: 'Greater than',
                greaterThanOrEqual: 'Greater than or equal',
                between: 'Between',
                dateIs: 'Date is',
                dateIsNot: 'Date is not',
                dateBefore: 'Date before',
                dateAfter: 'Date after'
            }
        },
        common: {
            name: 'Name',
            description: 'Description',
            title: 'Title',
            status: 'Status',
            enabled: 'Active',
            disabled: 'Disabled',
            enable: 'Enable',
            disable: 'Disable',
            save: 'Save',
            delete: 'Delete',
            cancel: 'Cancel',
            create: 'Create',
            add: 'Add',
            close: 'Close',
            actions: 'Actions',
            attention: 'Attention',
            loading: 'Loading...',
            error: 'An error occurred',
            noData: 'No data found',
            noTitle: 'Untitled',
            search: 'Search',
            clear: 'Clear',
            today: 'Today',
            tomorrow: 'Tomorrow',
            yes: 'Yes',
            no: 'No',
            confirm: 'Confirm',
            continue: 'Continue',
            apply: 'Apply',
            unknown: 'Unknown',
            success: 'Operation completed successfully',
            deleted: 'Deleted',
            edit: 'Edit',
            saved: 'Saved'
        },
        languages: {
            'it-IT': 'Italian',
            'en-GB': 'English'
        },
        filters: {
            title: 'Filters',
            clear: 'Clear filters',
            calendar: {
                reservationType: 'Reservation type',
                reservationTypes: {
                    internal: 'Internal use only',
                    external: 'Client visits only'
                },
                selectReservationType: 'Select reservation type',
                resourceTypes: 'Space types',
                selectResourceTypes: 'Select space types',
                resources: 'Spaces',
                selectResources: 'Select spaces',
                visitorType: 'Customer type',
                selectVisitorTypes: 'Select customer type',
                onlyMyReservations: 'View only my reservations',
                showMaintenance: 'Show maintenances'
            }
        },
        calendar: {
            title: 'Calendar',
            searchCustomerCode: 'Search registered customer',
            searchCustomerCodePlaceholder: 'Enter customer code or name...',
            searchCustomerCodeHelp: 'Start typing to search for a registered customer in the AS400 system',
            unconfirmedTooltip: 'Past visit not confirmed',
            preview: {
                resource: 'Space',
                otherResources: '+{count} other space | +{count} other spaces',
                owner: 'Created by',
                visitor: 'Customer',
                attendees: 'Attendees',
                notes: 'Notes',
                description: 'Description',
                maintenance: 'Maintenance',
                reducedCapacity: 'Reduced capacity',
                untitled: 'Untitled'
            },
            timezone: {
                browserLocalTime: 'Your browser time',
                differsAria: 'This space uses a different time zone from yours',
                unknown: 'Unrecognised time zone',
                unknownDetail: "The space's time zone is not recognised: times are shown in your browser's time zone."
            },
            changeConfirm: {
                title: 'Confirm {type}',
                move: 'move',
                resize: 'resize',
                info: 'Reservation details',
                titleField: 'Title',
                description: 'Description',
                resource: 'Space',
                visitor: 'Customer',
                noVisitor: 'No customer',
                attendees: 'Participants',
                timeSlot: 'Modify time slot',
                oldSlot: 'Previous slot',
                newSlot: 'New slot',
                duration: 'Duration',
                durationChange: 'Duration change',
                longer: 'longer',
                shorter: 'shorter',
                warning: 'By confirming this change, the reservation will be updated immediately in the calendar and saved in the system.',
                noChanges: 'No changes to confirm',
                confirmAction: 'Confirm change',
                updateSuccess: 'Reservation updated successfully'
            },
            edit: {
                title: 'Edit reservation',
                update: 'Update reservation'
            },
            new: {
                title: 'New reservation',
                subtitle: 'Fields marked with {char} are required',
                mandatoryFieldsHint: 'Fields marked with {char} are mandatory',
                reservationDetails: 'Reservation details',
                customerInfo: 'Customer information',
                resourcesAndSlots: 'Spaces and slots',
                internalResourceLimit: 'For internal use reservations, only one space can be selected',
                reviewAndConfirm: 'Summary and confirmation',
                step: 'Step {current} of {total}',
                prev: 'Previous',
                next: 'Next',
                reservationType: {
                    title: 'Reservation type',
                    visit: 'Customer visit',
                    visitDesc: 'Reservation for customers',
                    internal: 'Internal use',
                    internalDesc: 'Reservation for internal use (meetings, training, etc.)'
                },
                reservation: {
                    title: 'Title',
                    titlePlaceholder: 'Enter reservation title',
                    description: 'Description',
                    descriptionPlaceholder: 'Enter a description (optional)',
                    attendees: 'Number of participants',
                    notes: 'Additional notes',
                    notesPlaceholder: 'Enter any notes...'
                },
                visitors: {
                    title: 'Customer',
                    noVisitors: 'No customer selected',
                    add: 'Add customer',
                    addEdit: 'Add customer',
                    type: 'Customer type',
                    selectType: 'Select customer type',
                    firstName: 'First name',
                    firstNamePlaceholder: 'Enter customer first name',
                    lastName: 'Last name',
                    lastNamePlaceholder: 'Enter customer last name',
                    email: 'Email',
                    emailPlaceholder: 'Enter customer email',
                    details: 'Professional customer details',
                    country: 'Country',
                    countryPlaceholder: 'Enter country',
                    commercialSegment: 'Activity sector',
                    commercialSegmentPlaceholder: 'Enter activity sector',
                    functionary: 'Functionary',
                    agent: 'Agent',
                    businessName: 'Business name',
                    role: 'Role',
                    activitySector: 'Activity sector',
                    representsPurchaseGroup: 'Represents purchasing group'
                },
                resourcesSlots: {
                    resourceNotSelected: 'Space not selected',
                    slotNotSelected: 'Period not selected',
                    noSlotsAdded: 'No slots selected',
                    addAtLeastOneSlot: 'Select at least one slot to complete the reservation',
                    newSlot: 'New slot',
                    bookingSlot: 'Booking slot',
                    cannotChangeResource: 'Space cannot be changed after adding a slot',
                    selectResource: 'Select space',
                    selectResources: 'Select spaces',
                    defaultTime: 'Default time',
                    defaultTimeHint: 'Applies to all spaces below. You can override per space.',
                    configureSlots: 'Configure slots',
                    customTime: 'Custom time',
                    addTimeSlot: 'Add time slot',
                    addTimeSlotsForResource: 'Add one or more time slots for the selected space',
                    addAnotherTimeSlot: 'Add another time slot',
                    timezoneNotice: "Times are shown in the space's time zone ({zone}).",
                    customFields: {
                        title: 'Custom fields',
                        notes: 'Notes',
                        notesPlaceholder: 'Add optional notes...'
                    },
                    addSlot: {
                        title: 'Add slot',
                        resource: 'Space',
                        selectResource: 'Select a space',
                        noResourceAvailable: 'No space available',
                        date: 'Date',
                        startDate: 'Start date',
                        endDate: 'End date',
                        startTime: 'Start time',
                        endTime: 'End time',
                        slotPlaceholder: 'Select date and time',
                        duration: 'Duration',
                        durationFormat: '{hours} {hourUnit} and {minutes} {minuteUnit}',
                        save: 'Save slot',
                        datePlaceholder: 'Select date',
                        timePlaceholder: 'Select time',
                        validation: {
                            resourceRequired: 'Select a space',
                            slotRequired: 'Select start and end date and time',
                            startEndRequired: 'Start and end date and time are required',
                            dateRequired: 'Date is required',
                            timeRequired: 'Time is required',
                            endAfterStart: 'End time must be after start time',
                            overlapsReservation: 'The selected time overlaps with an existing reservation',
                            overlapsMaintenance: 'The selected time overlaps with a maintenance period'
                        },
                        error: {
                            resourceRequired: 'Select a space',
                            slotRequired: 'Select start and end date and time',
                            slotInvalid: 'Invalid period',
                            slotOverlap: 'The selected slot overlaps with another',
                            noResourcesAvailable: 'No spaces available'
                        }
                    },
                    timeline: {
                        title: 'Daily availability',
                        noAvailability: 'No availability for this day',
                        available: 'Available',
                        reservations: 'Reservations',
                        maintenance: 'Maintenance',
                        selected: 'Selected',
                        dateHint: 'Select a date to see space availabilities',
                        selectResourceAndDateHint: 'Select a space and a date to see availabilities',
                        datesWithAvailability: 'Dates in blue have configured availability',
                        dragHint: 'Click and drag on the timeline to select a time',
                        maxCapacity: 'max {capacity}',
                        partialMaintenance: 'Partial maintenance'
                    }
                },
                summary: {
                    title: 'Summary',
                    type: 'Reservation type',
                    reservation: 'Title',
                    attendees: 'Participants',
                    visitor: 'Customer',
                    bookedSlots: 'Booked slots',
                    date: 'Date'
                },
                preview: {
                    totalDuration: 'Total duration',
                    resources: 'Spaces',
                    today: 'Today',
                    tomorrow: 'Tomorrow'
                },
                switchType: {
                    confirmTitle: 'Switch reservation type',
                    confirmAccept: 'Confirm',
                    loseVisitorData: 'The entered customer data will be lost.',
                    loseSlotsData: 'Internal use reservations only support one space. The added slots will be removed.'
                },
                capacity: {
                    available: 'available',
                    notEnoughSpace: 'Insufficient capacity: requested {requested} seats, only {available} out of {total} available',
                    checkError: 'Error checking capacity',
                    badgeAria: 'Capacity: {available} of {total} seats available'
                },
                validation: {
                    titleRequired: 'Title is required',
                    attendeesRequired: 'Number of attendees must be greater than 0',
                    firstNameRequired: 'First name is required',
                    lastNameRequired: 'Last name is required',
                    emailRequired: 'Email is required',
                    countryRequired: 'Country is required',
                    commercialSegmentRequired: 'Commercial segment is required',
                    erpCustomerRequired: 'Select an ERP customer',
                    slotValidationError: 'Error validating slot',
                    formInvalid: 'Incomplete form',
                    formInvalidDetail: 'Complete all required fields before saving',
                    descriptionTooLong: 'Description cannot exceed 255 characters'
                },
                reservationsCreatedForEveryResource: 'Reservations will be created for each selected space.',
                save: 'Save reservation',
                error: {
                    create: 'Error creating reservation',
                    update: 'Error updating reservation'
                }
            },
            detail: {
                title: 'Reservation detail',
                info: 'Reservation information',
                client: 'Customer details',
                resources: 'Booked spaces',
                notes: 'Additional notes',
                createdBy: 'Created by',
                notAvailable: 'Not available',
                erpCode: 'ERP code',
                email: 'Email',
                purchaseGroup: 'Purchasing group',
                representsPurchaseGroup: 'Represents purchasing group',
                commercialSegment: 'Activity sector',
                country: 'Country',
                functionary: 'Functionary',
                agent: 'Agent',
                duration: 'Duration',
                notFound: 'Reservation not found',
                notFoundDetails: 'Unable to retrieve reservation details',
                deleteConfirmTitle: 'Confirm deletion',
                deleteConfirmMessage: 'Are you sure you want to delete this reservation? This action cannot be undone.',
                unknown: 'Unknown',
                rangeFormat: '{date} from {start} to {end}',
                deleteSuccess: {
                    title: 'Reservation deleted',
                    detail: 'The reservation has been successfully deleted'
                },
                deleteError: 'An error occurred while deleting the reservation',
                unconfirmedBanner: 'This visit has passed and has not been confirmed'
            }
        },
        visitor: {
            type: {
                nonProfessional: 'Non-Professional',
                newProfessional: 'Professional (New)',
                erpProfessional: 'Registered Professional',
                unknown: 'Unknown'
            }
        },
        resources: {
            title: 'Spaces management',
            searchByName: 'Search space by name...',
            name: 'Name',
            namePlaceholder: 'e.g. Meeting Room 1',
            type: 'Type',
            selectType: 'Select a type',
            location: 'Location',
            locationPlaceholder: 'e.g. Floor 2, East Wing',
            description: 'Description',
            descriptionPlaceholder: 'Optional description of the space...',
            timezone: 'Timezone',
            selectTimezone: 'Select a timezone',
            capacity: 'Capacity (people)',
            color: 'Color',
            enableCapacity: 'Enable capacity management',
            capacityPlaceholder: 'Maximum number of people',
            capacityHelp: 'Leave at 0 if not applicable',
            weeklyHours: 'Weekly hours',
            saveSuccess: 'Space saved successfully',
            newResource: 'New space',
            newResourceDescription: 'Add a new space to the system',
            editResource: 'Edit space',
            editResourceDescription: 'Edit space details',
            deleteResource: 'Delete space',
            deleteResourceConfirm: 'Confirm space delete',
            deleteWarning: 'You are about to permanently delete this space.\nThis operation cannot be undone.',
            noResourcesFound: 'No spaces found',
            tabs: {
                general: 'General information',
                availability: 'Availability',
                customFields: 'Custom fields'
            },
            customFields: {
                title: 'Associate custom fields',
                description: 'Select custom fields to associate with this space ({count} selected)',
                searchPlaceholder: 'Search custom field...',
                noFields: 'No fields available',
                noFieldsDescription: 'There are no custom fields available',
                noResults: 'No results for search',
                select: 'Select',
                selected: 'Selected',
                managementInfo: 'Field management',
                managementDescription: 'To create new custom fields, use the "Custom Fields" section from the main menu.',
                pageReport: 'Showing {first} - {last} of {totalRecords} fields'
            },
            types: {
                SHOWROOM: 'Showroom',
                MUSEUM: 'Museum',
                PRODUCTION_FACILITY: 'Production facility',
                BOARD_ROOM: 'Board room',
                MEETING_ROOM: 'Meeting room'
            },
            validation: {
                nameRequired: 'Space name is required',
                typeRequired: 'Select a space type',
                timezoneRequired: 'Select a timezone',
                capacityRequired: 'Capacity must be greater than 0',
                statusRequired: 'Select a status'
            }
        },
        userGroups: {
            title: 'User groups management',
            name: 'Group name',
            description: 'Description',
            users: 'Users',
            notifications: 'Notifications',
            new: 'New group',
            newGroup: 'New group',
            editGroup: 'Edit group',
            deleteGroup: 'Delete group',
            groupUsers: 'Group users',
            noUserGroupsFound: 'No user groups found',
            // Tabs
            tabs: {
                general: 'General',
                users: 'Users',
                notifications: 'Notifications'
            },

            // Descriptions
            createDescription: 'Create a new group and configure users and notifications',
            editDescription: 'Edit group, manage users and configure notifications',
            deleteConfirmDescription: 'Confirm group delete',
            selectUsersOptional: 'Select users to add to the group (optional - you can add users later)',
            manageGroupUsers: 'Add or remove users from this group',

            // Actions
            manageUsers: 'Manage users',
            manageNotifications: 'Manage notifications',

            // Form fields
            namePlaceholder: 'Enter group name',
            descriptionPlaceholder: 'Enter a description (optional)',
            nameRequired: 'Group name is required',

            // User management
            user: 'user',
            usersSelected: 'users selected',
            searchUsersPlaceholder: 'Search users by first name, last name or email...',
            noUsersFound: 'No users found',
            noUsersInGroup: 'No users in group',
            addUsersToGetStarted: 'Add users to get started',
            selectAll: 'Select all',
            deselectAll: 'Deselect all',

            // Notifications
            notificationsDescription: 'Configure the notifications this group will receive for each space type',
            resourcesConfigured: 'spaces configured',
            configureNotificationsToGetStarted: 'Configure notifications to get started',
            addResourceType: 'Add space type',
            addResourceTypes: 'Add space types',
            selectResourceType: 'Select space type',
            selectResourceTypes: 'Select space types',
            configureNotifications: 'Configure when to receive notifications',
            onCreate: 'New reservation',
            onUpdate: 'Reservation update',
            onDelete: 'Reservation cancellation',
            onUnconfirmed: 'Unconfirmed',
            associationActive: 'Association active',
            associationStatus: 'Association status',
            noNotificationsConfigured: 'No notifications configured',
            addResourceToStart: 'Select one or more space types to start',

            // Success/Error messages
            deleteWarning: 'You are about to permanently delete this group.\nThis operation cannot be undone.',
            deleteSuccess: 'Group delete successfully',
            deleteError: 'Unable to delete group',
            createSuccess: 'Group created successfully',
            updateSuccess: 'Group updated successfully',
            usersUpdateSuccess: 'Group users updated successfully',
            notificationsUpdateSuccess: 'Notification settings saved successfully',

            // Validation
            validation: {
                nameRequired: 'Group name is required',
                statusRequired: 'Please select a status'
            },
            searchByName: 'Search by name...',
            allCategories: 'All categories',
            groupActive: 'Group active',
            enableAllNotifications: 'Enable all notifications',
            disabledAllNotifcations: 'Disable all notifications',
            errorLoadingUsers: 'An error occurred while loading users',
            errorLoadingNotifications: 'An error occurred while loading notifications'
        },

        dataApi: {
            title: 'Data API'
        },

        users: {
            title: 'User management',
            searchByName: 'Search users by name...',
            username: 'Username',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            role: 'Role',
            selectRole: 'Select a role',
            type: 'User type',
            selectType: 'Select user type',
            edit: 'Edit',
            editUser: 'Edit user',
            editUserDescription: 'Edit user data and their role in the system',
            types: {
                user: 'User',
                admin: 'Administrator',
                superAdmin: 'System administrator',
                unknown: 'Unknown'
            },
            new: {
                title: 'New user',
                subtitle: 'Fields marked with {char} are mandatory'
            },
            saveSuccess: 'User saved successfully'
        },
        userNotifications: {
            title: 'User notifications',
            description: 'Notification management by space type',
            noNotifications: 'No notifications configured',
            noNotificationsDescription: 'There are no notifications configured for this user',
            resourceType: 'Space type'
        },
        status: {
            title: 'Status',
            enable: 'Active',
            disable: 'Disabled',
            select: 'Select status',
            unknown: 'Unknown',
            filterByStatus: 'Filter by status',
            all: 'All',
            planned: 'Planned',
            canceled: 'Canceled',
            completed: 'Completed'
        },

        // Maintenance section
        maintenance: {
            title: 'Maintenance management',
            subtitle: 'Manage maintenance periods and space availability',
            untitledSlot: 'New maintenance',
            changeSchedule: 'Schedule maintenance',
            scheduleFor: 'Schedule maintenance for',
            configuredSlots: 'Configured maintenance slots',
            addSlot: 'Add slot',
            untitled: 'Untitled',

            // Period filters
            period: {
                label: 'Period',
                selectRange: 'Select date range',
                quick: 'Quick period',
                thisMonth: 'This month',
                nextMonth: 'Next month',
                next3Months: 'Next 3 months',
                thisYear: 'This year'
            },

            // Status
            status: {
                active: 'Active',
                upcoming: 'Scheduled',
                completed: 'Completed'
            },

            // Space status
            inMaintenance: 'In maintenance',
            maintenanceScheduled: 'Maintenance scheduled',
            available: 'Available',
            noMaintenance: 'No maintenance scheduled',
            resourceAvailable: 'Space is available',

            // Timeline
            today: 'Today',
            total: 'Total maintenances',

            // Delete
            delete: {
                title: 'Delete maintenance',
                message: 'Confirm delete',
                warning: 'This action cannot be undone'
            },

            // Empty state
            empty: {
                title: 'No maintenance scheduled',
                subtitle: 'Start by add a new maintenance'
            },
            noMaintenances: 'No maintenance',
            noMaintenancesDesc: 'No maintenance scheduled for this period',
            noSlots: 'No slots',
            noSlotsDescription: 'No maintenance slots scheduled',
            noSlotsScheduled: 'No slots scheduled',
            clickAddToSchedule: 'Click "Add slot" to schedule a maintenance',
            form: {
                slots: 'Maintenance slots',
                slot: 'Slot',
                addSlot: 'Add slot',
                title: 'Title',
                titlePlaceholder: 'e.g., Routine maintenance',
                dayOfWeek: 'Day of week',
                selectDay: 'Select day',
                timeRange: 'Time range',
                startTimePlaceholder: 'Start (HH:mm)',
                endTimePlaceholder: 'End (HH:mm)',
                allDay: 'All day',
                validFrom: 'Valid from',
                validFromPlaceholder: 'Start validity date',
                validUntil: 'Valid until',
                validUntilPlaceholder: 'End validity date',
                description: 'Description',
                descriptionPlaceholder: 'Additional notes...',
                blockingMode: 'Blocking mode',
                blockingModeFully: 'Fully blocking',
                blockingModePartial: 'Reduced capacity',
                reducedCapacity: 'Capacity during maintenance',
                reducedCapacityHint: 'Maximum {max} (space capacity)'
            },
            blockingMode: {
                fully: 'Fully blocking',
                partial: 'Reduced capacity: {capacity}'
            },
            conflicts: {
                row: '{date} {start}–{end} · {attendees} attendees (max {cap})',
                more: '…and {count} more | …and {count} more'
            },
            validation: {
                resourceRequired: 'Space is required',
                titleRequired: 'Title is required for all slots',
                timesRequired: 'Start and end times are required',
                endTimeAfterStartTime: 'End time must be after start time',
                validUntilAfterValidFrom: 'End validity date must be after start date',
                saveFailed: 'An error occurred saving maintenance',
                loadFailed: 'An error occurred loading data',
                dayRequired: 'Select a day of the week',
                startTimeRequired: 'Enter a start time',
                endTimeRequired: 'Enter an end time',
                endAfterStart: 'End time must be after start time',
                reducedCapacityRequired: 'Enter the reduced capacity',
                reducedCapacityRange: 'Reduced capacity must be between 1 and {max}'
            }
        },
        settings: {
            language: 'Language',
            logout: 'Logout',
            profile: 'Profile',
            poweredBy: 'Powered by'
        },
        auth: {
            loggingIn: 'Logging in...'
        },

        // Common actions
        search: 'Search',
        close: 'Close',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
        add: 'Add',
        yes: 'Yes',
        no: 'No',
        confirm: 'Confirm',
        continue: 'Continue',
        clearFilters: 'Clear filters',
        actions: 'Actions',
        attention: 'Attention',
        saved: 'Saved',
        deleted: 'Deleted',
        error: {
            title: 'An error occurred',
            updateUser: 'Unable to update user',
            loadUsers: 'An error occurred loading users',
            noDataFromServer: 'No data received from server',
            deleteNotAllowed: 'Deletion not allowed',
            invalidTimeRange: 'The selected time range is not valid',
            resourceAlreadyBooked: 'The space is already booked for this time slot',
            resourceAvailabilityNotFullyCovered: 'The selected slot is not fully covered by the space availability',
            resourceCapacityExceeded: 'The maximum capacity of the space has been exceeded',
            resourceUnderMaintenance: 'The space is currently under maintenance',
            resourceCapacityReducedByMaintenance: 'The space capacity is reduced by a maintenance during this time range',
            resourceWithoutAvailability: 'The space has no configured availability',
            maintenanceConflictsWithReservations: 'Cannot save: some booked visits exceed the reduced capacity',
            invalidReducedCapacity: 'The reduced capacity is not valid for this space',
            invalidTimezone: 'The specified time zone is not valid',
            tooDistant: 'The selected date is too far in the future',
            overlapping: 'The selected slot overlaps with an existing slot'
        },
        errors: {
            generic: 'An unexpected error occurred',
            saveFailed: 'Unable to save data',
            http: 'Server error ({status})',
            saveSuccess: 'Data saved successfully',
            deleteSuccess: 'Item delete successfully'
        },
        loading: 'Loading...',

        // Custom fields
        customFields: {
            title: 'Custom fields',
            new: 'New field',
            edit: 'Edit field',
            delete: 'Delete field',
            titleField: 'Field title',
            description: 'Description',
            email: 'Email referent',
            resources: 'Spaces',
            deleteWarning: 'You are about to permanently delete this custom field.\nThis operation cannot be undone.',
            noCustomFields: 'No custom fields found',
            noDescription: 'No description',
            searchByTitle: 'Search by title...',
            allCategories: 'All categories',
            saveSuccess: 'Custom field saved successfully',
            validation: {
                titleRequired: 'Title is required',
                statusRequired: 'Please select a status'
            }
        },

        // Space types
        resourceTypes: {
            title: 'Space types',
            new: 'New space type',
            edit: 'Edit space type',
            delete: 'Delete space type',
            name: 'Name',
            description: 'Description',
            saveSuccess: 'Space type saved successfully',
            deleteWarning: 'You are about to permanently delete this space type.\nThis operation cannot be undone.',
            validation: {
                nameRequired: 'Name is required'
            }
        },

        // Availability
        availability: {
            manage: 'Manage availability',
            manageTitle: 'Manage availability - {name}',
            configTitle: 'Configure availability times',
            totalWeeklyHours: 'h',
            hoursPerWeek: 'hours/week',
            loading: 'Loading availability...',
            infoTitle: 'Availability management',
            infoDescription: 'You can create standard time slots (always valid) or custom ones (with a validity period). On the days a custom slot covers, only the custom slots apply: the standard ones are replaced, not added to. Leave the dates empty for always-active slots.',
            quickActions: 'Quick actions',
            weekdays: 'Weekdays',
            fullWeek: 'Full week',
            clearAll: 'Clear all',
            timeSlots: 'Time slots ({count})',
            addSlot: 'Add slot',
            days: {
                all: 'All',
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday'
            },
            configureSlots: 'Configure time slots',
            noSlots: 'No time slots defined',
            noSlotsDescription: 'Click "Add slot" or use quick actions to start',
            slotType: {
                custom: 'Custom',
                standard: 'Standard'
            },
            fields: {
                title: 'Title',
                titlePlaceholder: 'e.g. Standard time',
                description: 'Description (optional)',
                descriptionPlaceholder: 'Additional notes...',
                day: 'Day',
                selectDay: 'Select day',
                start: 'Start',
                end: 'End',
                validFrom: 'Valid from (optional)',
                validUntil: 'Valid until (optional)',
                datePlaceholder: 'Always valid if empty'
            },
            duration: 'Duration',
            from: 'From',
            until: 'Until',
            validRange: '{start} - {end}',
            validFromDate: 'From {date}',
            validUntilDate: 'Until {date}',
            validation: {
                invalidTime: 'Invalid time format. Use HH:MM (e.g. 09:00)',
                startBeforeEnd: 'Start time must be before end time',
                validFromBeforeUntil: 'Valid from date must be before valid until date',
                saveSuccess: 'Availability save successfully',
                loadError: 'Unable to load availability data',
                saveError: 'Unable to save availability. Please try again.',
                dayRequired: 'Select a day',
                startRequired: 'Enter a start time',
                endRequired: 'Enter an end time',
                endAfterStart: 'End time must be after start time'
            },
            pendingDeletions: 'Pending deletions',
            deleteNoReservations: 'Will be delete on save - no reservations affected',
            deleteWithReservations: 'Will be delete on save - related reservations will be cancelled',
            reason: 'Reason',
            undoDelete: 'Cancel',
            deleteSlotConfirm: {
                title: 'Delete availability slot',
                warning: 'This slot has reservations',
                hasReservations: 'There are reservations that depend on this availability slot. Deleting it will cancel all affected reservations.',
                reasonLabel: 'Cancellation reason',
                reasonPlaceholder: 'Explain why these reservations are being cancelled...',
                reasonHint: 'This reason will be communicated to customers whose reservations are cancelled.',
                proceed: 'Delete and cancel reservations'
            }
        },
        createReservation: {
            title: 'New reservation',
            prompt: 'Start the reservation creation process',
            selectedSlot: 'Selected time slot',
            date: 'Date',
            time: 'Time',
            duration: 'Duration',
            nextSteps: 'Next steps',
            step1: 'Enter reservation title and details',
            step2: 'Select customer and number of participants',
            step3: 'Choose spaces to book',
            loadingAvailability: 'Checking space availability...',
            noAvailableResources: 'No spaces available for the selected time slot'
        },
        cancelReservation: {
            title: 'Cancel reservation',
            confirm: 'Are you sure you want to cancel this reservation?',
            message: 'All booked spaces will be released and made available for other reservations.',
            warning: 'This operation cannot be undone.',
            success: 'Reservation cancelled successfully',
            error: 'An error occurred while cancelling the reservation'
        },
        confirmReservation: {
            title: 'Mark visit as completed',
            confirm: 'Are you sure you want to confirm this reservation?',
            message: 'The reservation will be saved and the spaces will be blocked for the selected period.',
            success: 'Reservation confirmed successfully',
            error: 'An error occurred while confirming the reservation'
        },
        // Time units
        time: {
            minute: 'minute | minutes',
            hour: 'hour | hours',
            day: 'day | days',
            morning: 'Morning',
            afternoon: 'Afternoon',
            evening: 'Evening'
        },
        menu: {
            reservations: 'Reservations',
            calendar: 'Calendar',
            newReservation: 'New reservation',
            resources: 'Spaces',
            maintenances: 'Maintenances',
            customFields: 'Custom fields',
            users: 'Users',
            groups: 'Groups'
        },
        days: {
            all: 'All days',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday'
        }
    }
};

export default enGB;
